<template>
  <div class="secure" style="padding:0 0 80px 0px; background:#fff; ">
    <div class="page-width" style="border-top:1px solid #eee; padding-top:80px;">
      <div class="title">
        <h2>
          无忧体系
          <span>/trust</span>
        </h2>
      </div>
      <div class="box carefree">
        <div class="flex1">
          <img width="45" src="@/assets/images/new-img/wy1.png" />
          <h4>品质无忧</h4>
          <p>餐饮食材源头直采，压缩中间流通环节，降低损耗，由田间地头直达餐厅后厨。完善的食品安全管控体系，实行高标准严审核，细节化管理确保商品品质。</p>
        </div>
        <div class="flex1">
          <img width="45" src="@/assets/images/new-img/wy2.png" />
          <h4>价格无忧</h4>
          <p>精简繁冗的中间渠道，降低商户供应链成本。食材新鲜低价直观透明，大大节省商户采购成本，省钱又省心。</p>
        </div>
        <div class="flex1">
          <img width="45" src="@/assets/images/new-img/wy3.png" />
          <h4>选择无忧</h4>
          <p>餐饮食材全品类覆盖，满足多样化需求。调料酒饮，你说我找，你要我有，提供无限选择隔日送达，满足特殊化需求。</p>
        </div>
        <div class="flex1">
          <img width="45" src="@/assets/images/new-img/wy4.png" />
          <h4>服务无忧</h4>
          <p>一键下单送货上门，“110极速达”，晚11点前下单生鲜商品，第二日10点前送达。同时，依托精准大数据分析及优势资源，提供店铺转租、商机加盟等信息，全方位解决餐饮难题。</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "secure"
};
</script>

<style lang="scss" scoped>
.page-width {
  width: 1050px;
  margin: 0 auto;
}
.secure {
  background: #f8f8f8;
  padding: 58px 0;
  .title {
    height: 60px;
    h2 {
      float: left;
      font-size: 40px;
      span {
        font-size: 18px;
        color: #757575;
      }
    }
    .more {
      float: right;
      font-size: 18px;
      padding-top: 8px;
      a {
        color: #757575;
        text-decoration: none;
        &:hover {
          color: #62b134;
          text-decoration: none;
        }
      }
    }
  }
  .recommend {
    margin-top: 15px;
    height: 280px;
    background: #fff;
    dt {
      float: left;
      width: 460px;
    }
    dd {
      float: right;
      width: 530px;
      margin-right: 20px;
      .name {
        padding: 35px 0;
        font-size: 24px;
      }
      .info {
        color: #757575;
        line-height: 1.8;
        text-align: justify;
      }
    }
  }
  a {
    color: #4a4a4a;
    text-decoration: none;
    &:hover {
      color: #62b134;
      text-decoration: none;
    }
  }
  .list {
    margin-top: 40px;
    dl {
      width: 326px;
      float: left;
      margin-right: 36px;
      .none {
        margin-right: 0;
      }
      dt {
        width: 326px;
        height: 180px;
      }
      dd {
        margin-top: 10px;
        .name {
          margin-top: 22px;
        }
        .time {
          color: #9b9b9b;
        }
      }
    }
  }
}
.box {
  display: flex;
}
.carefree div {
  padding: 20px 45px 10px;
}
.carefree div:first-child {
  padding: 20px 45px 10px 0;
}
.carefree div:last-child {
  padding: 20px 0px 10px 45px;
}
.carefree p {
  color: #757575;
  line-height: 25px;
  text-align: justify;
}
.carefree h4 {
  padding: 15px 0;
  color: #555;
  font-size: 21px;
}
</style>
